import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { IoMdArrowRoundForward } from "react-icons/io";
import { useFeedBack } from "../../context/FeedBackContext";
import UserHavePermission from "../../util/userHavePermissions";
import { mainPermissions } from "../../util/MenuLinks";
import CreatePayrrolModal from "../../components/CreatePayrrolModal";
import clsx from "clsx";
import PayrrolsFiltersComponent from "../../components/Payrrols/PayrrolsFiltersComponent";
import CustomTable from "../../components/CustomTable/CustomTable";
import DashboardPayrrolColumns from "../../components/CustomTable/Columns/DashboardPayrrolColumns";
import { Accordion, Button, Modal } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";

const Dashboard = ({ title }) => {

    const [showModal, setShowModal] = useState(false);

    const { user } = useAuth();

    const [show, setShow] = useState('cost-centers');

    const [showAlertModal, setShowAlertModal] = useState(false);

    const [filters, setFilters] = useState({
        name: ''
    });

    const [payrrolFilters, setPayrrolFilters] = useState({
        name: '',
        perPage: 1
    });

    const { setCurrentTitle } = useFeedBack();

    const [{ data, loading }, getDashboard] = useAxios({ url: `/dashboard`, params: filters }, { useCache: false });

    const [{ data: hasOpenPayrrol }, getHasOpenPayrrol] = useAxios({ url: `/dashboard/open-payrrol` }, { useCache: false });

    const [{ data: payrrolsData, loading: loadingPayrrols }, getPayrrols] = useAxios({ url: `/dashboard/payrrols`, params: payrrolFilters }, { useCache: false });

    const [currentCostCenters, setCurrentCostCenters] = useState([]);

    const [periodInfo, setPeriod] = useState({
        period: '',
        currentDate: '',
        currentDate2: ''
    });

    useEffect(() => {
        setCurrentTitle({
            title: `${title}`
        });
    }, [])

    useEffect(() => {
        if (hasOpenPayrrol) {
            if (hasOpenPayrrol?.data?.length > 0) setShowAlertModal(true);
        }
    }, [hasOpenPayrrol])

    useEffect(() => {
        var currentDate = new Date();
        var currentDate2 = currentDate.getDate() > 24 ? currentDate.setMonth(currentDate.getMonth() + 1) : currentDate.setMonth(currentDate.getMonth() - 1);
        var period = currentDate.getDate() > 24 ? `${format(new Date(), 'MMMM/yyyy', { locale: es })} - ${format(currentDate2, 'MMMM/yyyy', { locale: es })}` : `${format(currentDate2, 'MMMM/yyyy', { locale: es })} - ${format(new Date(), 'MMMM/yyyy', { locale: es })}`;
        setPeriod({
            currentDate: new Date(),
            currentDate2,
            period
        })
    }, [])

    return (
        <div>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <h3>
                        Periodo Actual:
                    </h3>
                    <b className="text-primary" style={{ textTransform: 'capitalize' }}>{periodInfo?.period}</b>
                </div>
                <div className="col-md-6 mb-3 text-end">
                    {
                        UserHavePermission(mainPermissions.payrrols?.[1]) &&
                        <button className="btn btn-primary mb-3" onClick={() => setShowModal('create-payrrols')}>
                            Crear Nóminas
                        </button>
                    }
                    <input
                        placeholder="Buscar..."
                        type="text"
                        className="form-control"
                        name="search"
                        onChange={(e) => setFilters((oldFilters) => { return { ...oldFilters, search: e.target.value } })}
                    />
                </div>
                <div className="col-md-6 text-center mb-3">
                    <button className={clsx(["btn btn-block border"], {
                        "btn-primary": show === "cost-centers"
                    })} onClick={() => setShow("cost-centers")}>
                        Centros de costo
                    </button>
                </div>
                <div className="col-md-6 text-center mb-3">
                    <button className={clsx(["btn btn-block border"], {
                        "btn-primary": show === "payrrols"
                    })} onClick={() => setShow("payrrols")}>
                        Procesos de nómina
                    </button>
                </div>
                {
                    show === 'cost-centers' ?
                        <>
                            {
                                loading &&
                                <div className="my-5">
                                    <div className="spinner">
                                        <div className="double-bounce1 bg-primary"></div>
                                        <div className="double-bounce2 bg-primary"></div>
                                    </div>
                                </div>
                            }
                            {
                                !loading &&

                                <Accordion defaultActiveKey="0">
                                    {
                                        data?.users?.map((user, i) => {
                                            return (
                                                <Accordion.Item eventKey={`${i}`} style={{ margin: 0 }} key={i}>
                                                    <Accordion.Header style={{ border: 'none', padding: 0 }}>

                                                        <div className="row w-100">
                                                            <div className="col-md-6">
                                                                <p className="text-primary mb-0">
                                                                    Nombre:
                                                                </p>
                                                                <p className="text-black">
                                                                    {user?.bossName}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <p className="text-primary mb-0">
                                                                    Centros de costos:
                                                                </p>
                                                                <p className="text-black">
                                                                    {user?.costCenters?.length}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <h4 className="text-black text-center">Listado de centros de costos</h4>
                                                        <ul className="list-group">
                                                            {
                                                                user?.costCenters?.map((costCenter, i2) => {
                                                                    return (
                                                                        <a href={`centro-de-costo/${costCenter?.id}`} className="list-group-item list-group-item-action list-group-item-primary">
                                                                            <div className="row">
                                                                                <div className="col-4">
                                                                                    <b>
                                                                                        {costCenter?.name}
                                                                                    </b>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <b>Trabajadores:</b> {costCenter?.workersCount}
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <b>Procesos de nóminas:</b> {costCenter?.payrrolsCount}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            )
                                        })
                                    }
                                </Accordion>
                            }
                        </>
                        :
                        null
                }

                {
                    show === 'payrrols' ?
                        <div className="col-md-12">
                            <PayrrolsFiltersComponent
                                filters={payrrolFilters}
                                setFilters={setPayrrolFilters}
                            />
                            <CustomTable
                                withoutGlobalActions
                                loading={loadingPayrrols}
                                title={"Procesos de nómina"}
                                pages={payrrolsData?.meta?.last_page}
                                total={payrrolsData?.meta?.total}
                                values={payrrolsData?.data}
                                currentPage={payrrolFilters?.page}
                                collumns={DashboardPayrrolColumns}
                                changePage={(page) => {
                                    if (payrrolsData?.meta?.last_page >= page && page > 0) {
                                        setPayrrolFilters((oldFilters) => {
                                            return {
                                                ...oldFilters,
                                                page: page
                                            }
                                        })
                                    }
                                }}
                                filters={payrrolFilters}
                                perPage={payrrolFilters?.perPage}
                                onPerPageChange={(e) => setPayrrolFilters((oldFilters) => {
                                    return {
                                        ...oldFilters,
                                        [e.target.name]: e.target.value
                                    }
                                })}
                            />
                        </div>
                        :
                        null
                }
            </div >
            <CreatePayrrolModal
                onCreate={() => getDashboard()}
                setShowModal={setShowModal}
                show={showModal === 'create-payrrols'}
            />

            <Modal show={showAlertModal} centered size="xl" onHide={() => setShowAlertModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        ⚠️ IMPORTANTE
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Hola, <span className="text-primary">{user?.name}</span> le informamos que tiene los siguientes proceso de nómina activos para este mes:
                    </p>
                    <div className="row">
                        {
                            hasOpenPayrrol?.data?.map((activePayrrol, i) => {
                                return (
                                    <div className="col-md-4 mb-3 border-none">
                                        <div className="card border p-2">
                                            <div className="d-flex align-items-center">
                                                <div className="col-8">
                                                    <p className="text-primary mb-0">
                                                        {activePayrrol?.costCenter?.name}
                                                    </p>
                                                    <small className="mb-0">
                                                        Trabajadores: {activePayrrol?.workersCount}
                                                    </small>
                                                    <br />
                                                    <small className="mb-0">
                                                        Periodo: {activePayrrol?.period}/{activePayrrol?.year}
                                                    </small>
                                                </div>
                                                <div className="col-4 text-end">
                                                    <a href={`/gestionar-nomina/${activePayrrol?.id}`} className="btn btn-primary btn-xs">
                                                        <IoMdArrowRoundForward />
                                                    </a>
                                                </div>
                                            </div>
                                            <span className={`btn btn-xs btn-${activePayrrol?.status?.variantColor}`}>
                                                {activePayrrol?.status?.name}
                                            </span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <p className="fw-bold">
                        Le agradecemos tomar en cuenta que el tiempo limite para finalizar el proceso es hasta el 12 del mes en curso.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="block" variant="primary" onClick={() => setShowAlertModal(false)}>
                        ENTENDIDO
                    </Button>
                </Modal.Footer>
            </Modal>
        </div >
    )
}

export default Dashboard;